// eslint-disable-next-line no-useless-escape
const specialCharacterRegEx = /[\(\)\{\}\[\],\+\-\*\/\<\>\=\?:]/g

const numberRegEx = /-?[0-9]+(\.[0-9]+)?/g
const stringRegEx = /"[^"]*"/g
const fieldRegEx = /\{(\w+)\}/g

function getAllMatches(regex, str) {
  const matches = []
  let match

  while ((match = regex.exec(str)) !== null) {
    matches.push(match)
  }

  return matches
}

export {
  specialCharacterRegEx,
  numberRegEx,
  stringRegEx,
  fieldRegEx,
  getAllMatches,
}
